<template>
  <div class="sf-el star-rating-input">
    <div class="sf-star-rating">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>
      <div class="sf-star-rating__wrap">
        <div class="sf-star-rating__stars">
          <button
            v-for="star in maxStars"
            :key="star"
            type="button"
            class="sf-star-rating__star"
            :class="{
              'sf-star-rating__star--active': star <= value,
              'sf-star-rating__star--hover': star <= hoverRating,
            }"
            @click="selectRating(star)"
            @mouseenter="hoverRating = star"
            @mouseleave="hoverRating = 0"
          >
            <BaseIcon
              :name="star <= value ? 'star-fill' : 'star'"
              size="24"
              class="sf-star-rating__icon"
              :class="{ 'sf-star-rating__icon--animate': star <= value }"
            />
          </button>
        </div>
        <span v-if="value > 0" class="sf-star-rating__value">{{ value }} / {{ maxStars }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { watch, ref, computed } from 'vue';
  import BaseIcon from '../../BaseIcon.vue';
  export default {
    name: 'StarRatingElement',
    components: {
      BaseIcon,
    },
    props: {
      label: String,
      description: String,
      caption: String,
      name: String,
      modelValue: {
        type: Number,
        default: 0,
      },
      maxStars: {
        type: Number,
        default: 5,
      },
      required: Boolean,
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const value = ref(props.modelValue || 0);
      const hoverRating = ref(0);

      // Convert maxStars to number if it's a string
      const maxStars = computed(() => {
        return typeof props.maxStars === 'string' ? parseInt(props.maxStars, 10) : props.maxStars;
      });

      const selectRating = (rating) => {
        value.value = rating;
        emit('update:modelValue', rating);
      };

      watch(
        () => props.modelValue,
        (newValue) => {
          value.value = newValue || 0;
        },
        { immediate: true }
      );

      return {
        value,
        hoverRating,
        maxStars,
        selectRating,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-star-rating {
    &__wrap {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    &__stars {
      display: flex;
      gap: 0.25rem;
    }

    &__star {
      background: none;
      border: none;
      font-size: 1.5rem;
      color: var(--slate-300);
      cursor: pointer;
      transition: color 0.2s ease;
      padding: 0.25rem;
      line-height: 1;

      &:hover {
        &:not(.sf-star-rating__star--active) {
          color: var(--amber-400);
        }
      }

      &--hover {
        color: var(--amber-400);
      }

      &--active {
        color: var(--amber-500);
      }

      &:focus {
        outline: 2px solid var(--cs-brand-primary);
        outline-offset: 2px;
        border-radius: 2px;
      }
    }

    &__value {
      font-size: 0.875rem;
      color: var(--slate-600);
      font-weight: 500;
    }
  }
</style>
